export default function Separator({ background }: { background?: string }) {
  return <span role="separator" style={{ background }} className="popover-menu-item--separator" />;
}
